import {connect} from 'react-redux'
import EventsGroup from '../components/events_group'
import { makeSelectSnapshotsIdByEvent } from '../selectors'

// Factory form: each mounted group gets its own memoized selector.
const makeMapStateToProps = () => {
  const selectSnapshotsIdByEvent = makeSelectSnapshotsIdByEvent();

  return (state, ownProps) => ({
    snapshotsId: selectSnapshotsIdByEvent(state, ownProps.events),
  });
}

export default connect(makeMapStateToProps)(EventsGroup)
